import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Checkbox } from 'ui/checkbox';
import { CHECKBOX_STATUS } from 'ui/checkbox/checkboxStatus';

import { SELECTABLE_ITEM_TYPE } from '../../constants';
import { toggleSelectionForItem } from '../../actions';

import { TableCell } from './TableCell';
import { selectIsItemSelected } from '../../selectors';

type CheckboxCellProps = {
  itemType: SELECTABLE_ITEM_TYPE;
  itemId: number;
};

export const CheckboxCell = ({ itemType, itemId }: CheckboxCellProps) => {
  const item = useMemo(
    () => ({
      type: itemType,
      id: itemId,
    }),
    [itemType, itemId],
  );
  const dispatch = useDispatch();
  const handleCheckboxClick = useCallback(() => {
    dispatch(toggleSelectionForItem(item));
  }, [dispatch, item]);
  const checkboxStatus = useSelector(selectIsItemSelected(item))
    ? CHECKBOX_STATUS.CHECKED
    : CHECKBOX_STATUS.UNCHECKED;

  return (
    <TableCell data-test="checkbox-grid-cell">
      <Checkbox
        data-test="checkbox-grid-cell-checkbox"
        id={`checkbox-${itemType}-${itemId}`}
        onClick={handleCheckboxClick}
        status={checkboxStatus}
      />
    </TableCell>
  );
};
